import Forward from "@/views/Forward.vue";

export default (rootPath) => {
  return [
    {
      path: "",
      component: Forward,
      redirect: `${rootPath}/list`,
      hidden: true,
      children: [
        {
          path: "list",
          component: () => import("@/views/table/StoresTable.vue"),
          meta: { title: "Список магазинов", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "create",
          component: () => import("@/views/forms/StoresForm.vue"),
          meta: { title: "Создать магазин", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "edit/:id",
          component: () => import("@/views/forms/StoresForm.vue"),
          meta: { title: "Редактировать магазин", activeMenuParent: true },
          hidden: true,
        },
      ],
    },
  ];
};
